module.exports = __webpack_public_path__ + "static/media/graphic-design.65680fd9.svg";